import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue"

import { ref, watch, nextTick, computed } from 'vue';
import type { Ref, CSSProperties } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'ToolTip',
  props: {
    show: { type: Boolean },
    text: {},
    targetElement: {}
  },
  setup(__props: any) {

const props = __props;

const position = ref({ x: 0, y: 0 });
const arrowLeft = ref<number | null>(null);
const tooltipRef: Ref<HTMLElement | null> = ref(null);

const tooltipStyle = computed((): CSSProperties => ({
    top: `${position.value.y}px`,
    left: `${position.value.x}px`,
}));

const arrowStyle = computed((): CSSProperties => ({
    left: arrowLeft.value !== null ? `${arrowLeft.value}px` : '50%',
}));


watch(() => [props.show, props.targetElement], async ([newShow, newTarget]) => {
    if (newShow && newTarget && typeof newTarget === 'object') {
        await nextTick();

        const targetRect = newTarget.getBoundingClientRect();
        const tooltipEl = tooltipRef.value;
        if (!tooltipEl) return;
        const tooltipRect = tooltipEl.getBoundingClientRect();

        const spacing = 8;

        let y = targetRect.top - tooltipRect.height - spacing;
        let x = targetRect.left + (targetRect.width / 2) - (tooltipRect.width / 2);

        const viewportWidth = window.innerWidth;
        if (x < spacing) {
            x = spacing;
        } else if (x + tooltipRect.width > viewportWidth - spacing) {
            x = viewportWidth - tooltipRect.width - spacing;
        }

        if (y < spacing) {
            y = targetRect.bottom + spacing;
        }

        const targetCenter = targetRect.left + targetRect.width / 2;
        arrowLeft.value = targetCenter - x;


        position.value = { x, y };
    }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_Transition, { name: "tooltip-fade" }, {
      default: _withCtx(() => [
        (_ctx.show)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              ref_key: "tooltipRef",
              ref: tooltipRef,
              class: "tooltip-container",
              style: _normalizeStyle(tooltipStyle.value)
            }, [
              _createTextVNode(_toDisplayString(_ctx.text) + " ", 1),
              _createElementVNode("div", {
                class: "tooltip-arrow",
                style: _normalizeStyle(arrowStyle.value)
              }, null, 4)
            ], 4))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})